import { FEATURE_FLAGS, useFeatureFlags } from '@feature-flags/index';
import { venuesStartingPriceSelector } from '@redux/experiments/selectors/venues-starting-price';
import { useAppSelector } from '@redux/hooks';
import { useMemo } from 'react';

export const useShouldShowPricingFilter = () => {
	const featureFlags = useFeatureFlags();
	const isReceptionVenue = useAppSelector(
		(state) => state.category.code === 'REC',
	);
	const isInVenuesStartingPriceExperiment = useAppSelector(
		(state) => venuesStartingPriceSelector(state) === 'venues-starting-price',
	);

	return useMemo(() => {
		const isListingsPricingEnabled =
			featureFlags[FEATURE_FLAGS.LISTINGS_PRICING];
		if (isReceptionVenue) {
			return isListingsPricingEnabled && isInVenuesStartingPriceExperiment;
		}
		return isListingsPricingEnabled;
	}, [
		featureFlags[FEATURE_FLAGS.LISTINGS_PRICING],
		isInVenuesStartingPriceExperiment,
		isReceptionVenue,
	]);
};
